import { StepButton as MuiStepButton, StepButtonProps as MuiStepButtonProps } from '@mui/material';
import React from 'react';

export type StepButtonProps = MuiStepButtonProps;

export const StepButton = (props: StepButtonProps) => {
  return <MuiStepButton {...props} />;
};
